
import IdeDesc from '../../components/IdeDesc'
import CodeEditor from '../../components/CodeEditor.js'
import CodeOutput from '../../components/CodeOutput.js';
import React, { useState,useRef, useEffect } from 'react';
import { getQuestionInfo, getAllQuestions, getQuestionSolutions, addSubmission, getQuestionSubmissions, getAIFeedback } from '../../api/axios.js';
import { useParams, useNavigate } from 'react-router-dom';
import { transformTestCases,getSubmitCodeHelper } from '../../functions/ide_functions.js';
import { Box, Typography, Button, CircularProgress, Card, CardContent,Select,MenuItem} from '@mui/material';
import { executeCode } from "../../components/Api.js";
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';	
import {Panel,PanelGroup,PanelResizeHandle} from "react-resizable-panels"
import AiCircle from '../../components/AiCircle';
import { useUser } from '../../context/userContext.js';
import { track } from '@vercel/analytics';

import {
  TypeEnum,
  check_and_convert_all,
  getCreationFunctions,
  getDataStructureDefinitions,
} from "../../functions/data_structure.js";
import zIndex from '@mui/material/styles/zIndex.js';

const IdeNew = () => {   
    
    
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [example, setExample] = useState('');
    const [constraints, setConstraints] = useState([]);
    const [testCases, setTestCases] = useState([]);
    const [testCaseInputTypes, setTestCaseInputTypes] = useState([]);
    const [modelOutput, setModelOutput] = useState([]);
    const [codeTemplates, setCodeTemplates] = useState(null);
    const [submitCodeHelper,setSubmitCodeHelper]= useState('');
    const [questionList, setQuestionList] = useState([]);
    const [activeCaseButton, setActiveCaseButton] = useState(0);
    const {idQuestion} = useParams();
    
    const [solution, setSolution] = useState('')
    const [solutions, setSolutions] = useState('')  
    
    
    const [submitStatus, setSubmitStatus] = useState(false);    
    const [language, setLanguage] = useState("python");
    const [wrongTestCases, setWrongTestCases] = useState([]);
    const [rightBottomActiveButton, setRightBottomActiveButton] = useState('Test Case');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null); 
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [submissions, setSubmissions] = useState([]);
    const [submission, setSubmission] = useState(null);
    const [aiFeedback, setAiFeedback] = useState("");
    const [outputs, setOutputs] = useState([]); 
    const [selectedQuestion, setSelectedQuestion] = useState("");
    const [timer, setTimer] = useState(0);
    const [chatStatus, setChatStatus] = useState(false);
    const timerRef = useRef(null);

    const navigate = useNavigate();
    const { refreshSubscription } = useUser();
    
    const editorRef = useRef(null);

    const rightBottomButtonList =['Test Case','Output'] 

    const handleBottomButtonClick = (buttonName) => {
      setRightBottomActiveButton(buttonName);     
  
      
    };

    const handleChatStatus=(boolean)=>{
      setChatStatus(boolean);
    }

    
  
    const handleLanguageChange = (language) => {
      setLanguage(language);
    };

    const handleCaseClick = (index) => {
      setActiveCaseButton(index);
    };
    

    const handleMount = (editor) => {
      editorRef.current = editor;
      editor.focus();
    };

    const handleQuestionChange = (event) => {
      const selectedQuestion = questionList.find(
        (q) => q.title === event.target.value
      );
      setSelectedQuestion(event.target.value);
      if (selectedQuestion) {
        navigate(`/ideNew/${selectedQuestion._id}`);
        setSubmitStatus(false);
      }
    };

    const submitCode = async () => {
      
      setIsSubmitLoading(true);
      setError(null);
    
      let outputArray = [];
      let resultStatus = "Accepted";
      let wrongCases = [];
    
      try {
        for (let i = 0; i < testCases.length; i++) {
          const formattedTestCase = getCreationFunctions(testCases[i], testCaseInputTypes);          
          const dataStructureDefinitions = getDataStructureDefinitions(testCaseInputTypes, testCases[i]);
          console.log("languages and codeTemplates",language,codeTemplates);
          const submitCodeHelper = getSubmitCodeHelper(language, codeTemplates);
          console.log("SubmitCodeHelper",submitCodeHelper);
          const sourceCode = `
${dataStructureDefinitions}
${editorRef.current.getValue()}
${submitCodeHelper}${formattedTestCase}));
      `; // if its java must add }} above

          if (!sourceCode) return;
          const response = await executeCode(language, sourceCode);
          console.log(response);
          const result=response.data;
          if (result.error) {
            outputArray.push(result.error);
            wrongCases.push(i);
            resultStatus = "Runtime Error";
          } else if (
            result.output.replace(/\s+/g, "") !==
            modelOutput[i].replace(/\s+/g, "")
          ) {
            outputArray.push(result.output);
            wrongCases.push(i);
            resultStatus = "Wrong Answer";
          } else if (result.output.trim() === "None") {
            wrongCases.push(i);
            outputArray.push(result.output.trim());
            resultStatus = "Failed";
          } else {
            outputArray.push(result.output.trim());
            track("Code Submission - Submit");
          }
        }

        
    
        // Submit code to the backend
        const submissionPayload = {
          idQuestion,
          content: editorRef.current.getValue(),
          language: language,
          results: resultStatus,
          timer: timer,
          query:"",
          context:""
        };
         
        setTimer(0);     
        sessionStorage.removeItem('timer');
        
    
        const submitResponse = await addSubmission(submissionPayload);
        console.log("submitResposne",submitResponse);
        //setSubmission(submitResponse.data);
        // console.log("aiFeedback",submitResponse.data.feedback?.content,typeof(submitResponse.data.feedback?.content))
        // setAiFeedback(
        //   submitResponse.data.feedback?.content || "AI feedback unavailable. Please try again later."
        // );
    
        setSubmitStatus(true);
        //handleChatStatus(false); 
      } catch (error) {
        setError(error);
        console.error(error);
      } finally {
        setIsSubmitLoading(false);        
        setRightBottomActiveButton("Output");
        setActiveCaseButton(0);
      }
    
      setWrongTestCases(wrongCases);
      setOutputs(outputArray);
      console.log("outputs",outputs);
    };

    const getAiInsights= async()=>{
      const aiFeedbackPayload = {
        idQuestion,
        content: editorRef.current.getValue(),     

      };
      try{
        const insightsResponse=await getAIFeedback(aiFeedbackPayload);
        setAiFeedback(insightsResponse.data.data);

      }
      catch(error){
        console.error("Error fetching insights feedback:", error);
        setAiFeedback("The AI Model is down right now, please try again later");


      }

    }

    const handleSubmit = ()=>{       
      setWrongTestCases([]);    
      setOutputs([]);
      setSubmitStatus(false);
      handleChatStatus(true);         
      submitCode();
      setAiFeedback('');
      getAiInsights();
    }  

    const handleReset = () => {
      if (editorRef.current) {
        editorRef.current.setValue(codeTemplates[language]);
      }
      setWrongTestCases([]);    
      setRightBottomActiveButton('Test Case');
      setOutputs([]);
      setSubmitStatus(false);
      if (aiFeedback!==""){
        handleChatStatus(true);

      }      
      
    }

    const handleRun = ()=>{
      setWrongTestCases([]);  
      setOutputs([]);
      setSubmitStatus(false);    
      runCode();
    } 

    const runCode = async () => {
      setIsLoading(true);
      setError(null);
    
      let outputArray = [];
      let wrongCases = [];
    
      try {
        for (let i = 0; i < testCases.length; i++) {
          const formattedTestCase = getCreationFunctions(testCases[i], testCaseInputTypes);
          
          const dataStructureDefinitions = getDataStructureDefinitions(testCaseInputTypes, testCases[i]);
          const submitCodeHelper = getSubmitCodeHelper(language, codeTemplates);
          const sourceCode = `
${dataStructureDefinitions}
${editorRef.current.getValue()}
${submitCodeHelper}${formattedTestCase})); 
      `; // if its java must add }} above
          console.log(`code sent to compiler: ${sourceCode}`)
          console.log(`formatted test case input: ${formattedTestCase}`)
          if (!sourceCode) return;
          const response = await executeCode(language, sourceCode);
          console.log(response);
          const result=response.data;          
          if (result.error) {
            outputArray.push(result.error);
            wrongCases.push(i);
          } else if (result.output.trim() === "None") {
            
            if(modelOutput[i].replace(/\s+/g, "")=="[]"){
              outputArray.push(result.output.trim());
              track("Code Submission - Run");
            }else{
              wrongCases.push(i);
              outputArray.push(result.output.trim());

            }
            
          }else if (
            result.output.replace(/\s+/g, "") !==
            modelOutput[i].replace(/\s+/g, "")
          ) {
            outputArray.push(result.output);
            wrongCases.push(i);
          }  else {
            outputArray.push(result.output.trim());
            track("Code Submission - Run");
          }
        }
    
        setSubmitStatus(true);
      } catch (error) {
        setError(error);
        console.error(error);
      } finally {
        setIsLoading(false);
        setRightBottomActiveButton("Output");
        setActiveCaseButton(0);
      }
    
      setWrongTestCases(wrongCases);
      setOutputs(outputArray);
      console.log(outputs);
    };

    
    
    useEffect(() => {
        const fetchQuestionInfo = async () => {
            try {
                const response = await getQuestionInfo(idQuestion);
                const questionSolutions = await getQuestionSolutions(response.data._id);
                const transformedTestCases = transformTestCases(response.data.test_case_input);
                console.log("testCases",transformedTestCases);
                console.log("starterCode",response.data.starterCode);
    
                setTitle(response.data.title);
                setDescription(response.data.description);
                setExample(response.data.example);
                setConstraints(response.data.constraints);
                setTestCases(transformedTestCases);                
                setSolution(response.data.solution);
                setModelOutput(response.data.test_case_output);
                setCodeTemplates(response.data.starterCode);
                setSolutions(questionSolutions.data);
                setSubmitCodeHelper(response.data.submitCodeHelper);
                setTestCaseInputTypes(response.data.test_case_input_types);
                console.log("solutions",questionSolutions.data);
            } catch (error) {
                console.error('Error fetching question info:', error);
            }
        };
        fetchQuestionInfo();
        setSubmitStatus(false)
    }, [idQuestion]);

    useEffect(() => {
        const fetchAllQuestions = async () => {
          try {
            const response = await getAllQuestions();
            setQuestionList(response.data);
          } catch (error) {
            console.error("Error fetching all questions:", error);
          }
        };
        fetchAllQuestions();
      }, []);

    useEffect(() => {
      if (codeTemplates && editorRef.current) {
        if (codeTemplates[language]) {
          editorRef.current.setValue(codeTemplates[language]);
        } else {
          editorRef.current.setValue("");
        };
      }
    }, [codeTemplates, language]);

    useEffect(() => {
      const fetchSubmissions = async () => {
        try {
          const response = await getQuestionSubmissions(idQuestion);
          const sortedSubmissions = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setSubmissions(sortedSubmissions);
          console.log("submissions received:", submissions);
        } catch (error) {
          console.error("Error fetching question submissions:", error);
        }
      };
      fetchSubmissions();
    }, [idQuestion, submitStatus]);

    useEffect(() => {
      function hideError(e) {
          if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
              const resizeObserverErrDiv = document.getElementById(
                  'webpack-dev-server-client-overlay-div'
              );
              const resizeObserverErr = document.getElementById(
                  'webpack-dev-server-client-overlay'
              );
              if (resizeObserverErr) {
                  resizeObserverErr.setAttribute('style', 'display: none');
              }
              if (resizeObserverErrDiv) {
                  resizeObserverErrDiv.setAttribute('style', 'display: none');
              }
          }
      }
  
      window.addEventListener('error', hideError)
      return () => {
          window.addEventListener('error', hideError)
      }
  }, [])

  useEffect(() => {
    // Check session storage for existing timer value
    const storedTimer = sessionStorage.getItem('timer');
    if (storedTimer) {
      setTimer(parseInt(storedTimer, 10));
    }

    // Start the timer
    timerRef.current = setInterval(() => {
      setTimer(prevTimer => {
        const newTimer = prevTimer + 1;
        //console.log(`Timer: ${newTimer} seconds`); // Log the live timer
        sessionStorage.setItem('timer', newTimer); // Update session storage
        return newTimer;
      });
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(timerRef.current);
  }, []);

  // Might need to change this to something else to real-time cap the insights
  // useEffect(() => {
  //     refreshSubscription();
  //   }, [location.pathname]);

  return (  
    <Box sx={{height:'90vh',zIndex:10000}}> 
      <PanelGroup
          autoSaveId='horizontalBoxes'
          direction='horizontal'
        >

        <Panel defaultSize={50} minSize={20}>
      
          <Box sx={{height:'90vh',margin: "10px",marginRight:'2px'}}>
              <IdeDesc 
                  description={description}
                  example={example}
                  constraints={constraints}
                  solutions={solutions}                  
                  submissions={submissions}
                  questionList={questionList}
                  title={title}
                  handleQuestionChange={handleQuestionChange}
                  selectedQuestion={selectedQuestion}
                  submitStatus={submitStatus}
              />
          </Box>
        </Panel>

        <PanelResizeHandle>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Box sx={{ borderLeft: '3px solid #5D2A79',borderRadius:"5px", height: '30px' }} />
          </Box>
        </PanelResizeHandle>       

        <Panel defaultSize={50} minSize={25}>
        
          <Box sx={{margin: "10px", marginLeft:'2px', height:'90vh'}}>

            <PanelGroup
              autoSaveId='example'
              direction='vertical'
            >
              <Panel defaultSize={75} minSize={7}>                 
                <CodeEditor
                    handleReset={handleReset}
                    handleRun={handleRun}
                    isLoading={isLoading}
                    handleSubmit={handleSubmit}
                    isSubmitLoading={isSubmitLoading}
                    codeTemplates={codeTemplates}
                    editorRef={editorRef}
                    handleMount={handleMount}
                    handleLanguageChange={handleLanguageChange}
                    height={window.innerHeight}
                    
                    
                />                            

              </Panel> 

              <Box sx={{marginTop:'2px'}}>
                <PanelResizeHandle>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Box sx={{ borderLeft: '30px solid #5D2A79',borderRadius:"5px", height: '3px' }} />
                  </Box>
                </PanelResizeHandle>
              </Box> 

              

              <Panel defaultSize={25} minSize={7}>                
                <CodeOutput
                    rightBottomButtonList={rightBottomButtonList}
                    handleButtonClick={handleBottomButtonClick}
                    rightBottomActiveButton={rightBottomActiveButton}
                    testCases={testCases}
                    activeCaseButton={activeCaseButton}
                    submitStatus={submitStatus}
                    outputs={outputs}
                    handleCaseClick={handleCaseClick}
                    modelOutput={modelOutput}
                    wrongTestCases={wrongTestCases}
                  />                
              </Panel>
            </PanelGroup>
          </Box>
        </Panel>
      </PanelGroup>
      <AiCircle
          submitStatus={submitStatus}
          aiFeedback={aiFeedback}
          getAIFeedback={getAIFeedback}
          handleChatStatus={handleChatStatus}
          setAIFeedback={setAiFeedback}
          chatStatus={chatStatus}
          
        />      
    </Box> 
    
      
  )
}

export default IdeNew